export default __webpack_public_path__ + "static/media/malmo.b1ff2be7.png";